import { render, staticRenderFns } from "./asset-group-category-boxes.vue?vue&type=template&id=39dfd8e9&scoped=true"
import script from "./asset-group-category-boxes.vue?vue&type=script&lang=js"
export * from "./asset-group-category-boxes.vue?vue&type=script&lang=js"
import style0 from "./asset-group-category-boxes.vue?vue&type=style&index=0&id=39dfd8e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dfd8e9",
  null
  
)

export default component.exports